export default __webpack_public_path__ + "static/media/logo-without-text.bd56f947.svg";